import { render, staticRenderFns } from "./make-a-short-video-or-audio-tutorial-for-a-hobby-you-love.vue?vue&type=template&id=3a6b23c1&"
import script from "./make-a-short-video-or-audio-tutorial-for-a-hobby-you-love.vue?vue&type=script&lang=js&"
export * from "./make-a-short-video-or-audio-tutorial-for-a-hobby-you-love.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports